module.exports = __webpack_public_path__ + "static/img/4.84d34eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/eng/4.png
// module id = QDWF
// module chunks = 0